import { useState } from 'react';
import { S3Image } from '../S3Image';
import { cn } from '../../lib/utils';

export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  const initials =
    parts.length === 1
      ? parts[0].slice(0, 2)
      : `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`;
  return initials.toUpperCase();
}

interface InitialsAvatarProps {
  name: string;
  imageUrl?: string | null;
  size?: number;
  className?: string;
}

/** Circular publisher/user avatar: image when available, else initials on blue. */
export function InitialsAvatar({
  name,
  imageUrl,
  size = 32,
  className,
}: InitialsAvatarProps) {
  // Fade the bitmap in once it has loaded; a new URL fades in again.
  const [loadedUrl, setLoadedUrl] = useState<string | null>(null);
  return (
    <div
      aria-hidden="true"
      style={{ width: size, height: size }}
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-blue-600 text-white',
        className,
      )}
    >
      {imageUrl ? (
        <S3Image
          src={imageUrl}
          alt=""
          useThumbnail={false}
          width={size}
          height={size}
          onLoad={() => setLoadedUrl(imageUrl)}
          className={cn(
            'size-full object-cover transition-opacity duration-200 ease-out',
            loadedUrl === imageUrl ? 'opacity-100' : 'opacity-0',
          )}
        />
      ) : (
        <span
          className="font-bold leading-none"
          style={{ fontSize: Math.max(9, Math.round(size * 0.35)) }}
        >
          {getInitials(name)}
        </span>
      )}
    </div>
  );
}
